import { useState } from 'react';
import faqMain from '../assets/images/faqmain.png';
import faqSub from '../assets/images/faq_sub.png';
import { FaArrowRight } from 'react-icons/fa';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      category: "About DI Labs",
      items: [
        {
          question: "What is DI Labs?",
          answer: "DI Labs is a portfolio website showcasing mobile applications that we have developed and published on the Google Play Store and Apple App Store. We specialize in creating high-quality Flutter applications across various categories."
        }
        
      ]
    },
    {
      category: "Using Featured Apps",
      items: [
        {
          question: "Which platforms are your apps available on?",
          answer: "Our apps are available on both Android (Google Play Store) and iOS (Apple App Store). Each app page indicates which platforms it supports."
        }
      
      ]
    },
    {
      category: "Custom App Development Services",
      items: [
        {
          question: "Can you develop a custom app for me or my business?",
          answer: "Yes! We offer custom mobile app development services. If you're interested in creating an app similar to one in our portfolio or have a unique idea, we'd love to discuss it with you."
        },
       
      ]
    },
    {
      category: "Technical Questions",
      items: [
        {
          question: "What technologies do you use for app development?",
          answer: "We primarily develop apps using Flutter, which allows us to create high-quality cross-platform applications for both iOS and Android from a single codebase. We also use Firebase for backend services and various native technologies when needed."
        },
        {
          question: "Can you integrate my app with existing systems or APIs?",
          answer: "Yes, we have experience integrating apps with various third-party services, APIs, databases, and existing business systems. Let us know your integration requirements when you contact us."
        }
        
      ]
    },
    {
      category: "Business & Legal",
      items: [
        {
          question: "What are your payment terms for custom projects?",
          answer: "Payment terms are typically structured in milestones based on project phases (e.g., design approval, development completion, testing, launch). We'll discuss and agree on specific payment terms before starting your project."
        },
        {
          question: "Do you offer refunds?",
          answer: "Refund policies for custom development projects are outlined in the project contract. For apps downloaded from app stores, please refer to the respective store's refund policy."
        }
       
      ]
    },
    {
      category: "Contact & Support",
      items: [
        {
          question: "What's the best way to contact you?",
          answer: "Email us at support@dilabs.com for all inquiries including support requests, custom development projects, business opportunities, and general questions."
        }
       
      ]
    }
  ];

  // Flatten all FAQ items into a single array
  const allFAQs = [];
  faqData.forEach((category) => {
    category.items.forEach((item) => {
      allFAQs.push(item);
    });
  });

  return (
    <section className="faq-section" id='faq'>
      <div className="faq-container">
        <div className="faq-header">
          <span className="faq-badge">FAQs</span>
          <h1 className="faq-main-heading">
            <span>Got Questions?</span> We've Got Answers.
          </h1>
          <p className="faq-intro">
            Find quick answers to the most common questions about our services, development process,
            timelines, and support. We're here to make every step simple and transparent.
          </p>
        </div>

        <div className="faq-content">
          <div className="faq-accordion">
            {allFAQs.slice(0, 5).map((item, index) => {
              const isOpen = openIndex === index;
              
              return (
                <div key={index} className={`faq-item ${isOpen ? 'active' : ''}`}>
                  <button
                    className={`faq-question ${isOpen ? 'active' : ''}`}
                    onClick={() => toggleFAQ(index)}
                    type="button"
                    aria-expanded={isOpen}
                  >
                    <span className="faq-question-text">{index + 1}. {item.question}</span>
                    <span className="faq-icon">
                      <FaArrowRight className="faq-arrow-svg" />
                    </span>
                  </button>
                  {isOpen && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          <div className="faq-image-stack" aria-hidden="true">
            <img className="faq-main-image" src={faqMain} alt="" />
            <img className="faq-sub-image" src={faqSub} alt="" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default FAQ;

